export const checkCircleInvertedIcon = `
<svg width="82" height="83" viewBox="0 0 82 83" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2.5" y="2.85498" width="77" height="77" rx="38.5" stroke="var(--zbp-svg-primary-color, black)" stroke-width="5"/>
<path d="M22.1953 41.3269L34.7504 53.882L60.3204 28.312" stroke="var(--zbp-svg-primary-color, black)" stroke-width="4.16667"/>
</svg>
`;
